import type { PropertyDTO } from "@zplanem/responses"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

interface Props {
	property: Pick<PropertyDTO, "type" | "customType">
	className?: string
	size?: "sm" | "lg"
}

const SIZE_CLASSES = {
	sm: "text-[10px] tracking-[0.12em]",
	lg: "text-lg tracking-[0.1em]",
} as const

export function PropertyTypeBadge({
	property,
	className = "",
	size = "sm",
}: Props) {
	const { locale } = useLocale()
	const t = getTranslations(locale)

	const label =
		property.type === "other"
			? (property.customType ?? t.properties.types.other)
			: t.properties.types[property.type]

	return (
		<span
			className={`inline-block uppercase font-semibold text-[color:var(--ring)] ${SIZE_CLASSES[size]} ${className}`}
		>
			{label}
		</span>
	)
}
